import React, { useState, useEffect } from "react";
import assets from "../../../assets/assets";
import styled from "styled-components";
import axios from "axios";
import { distributionUrl } from "../../Config/url";
import { IconController } from "../../Scripts/ImgController";
import { useNavigate } from "react-router-dom";
import Ripples from "react-ripples";
const ChangeButton = styled.div`
  background: #0061ff;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-radius: 8px;
`;
const ModalChangePassword = ({
  otpNumbers,
  forgotEmail,
  setOtpInput,
  setPopup,
  setPopupType,
  setPopupMessage,
}) => {
  const formData = new FormData();
  const navigate = useNavigate();

  const [passwordReveal, setPasswordReveal] = useState("password");
  const [passwordRepeatReveal, setPasswordRepeatReveal] = useState("password");

  const [passwordInput, setPasswordInput] = useState("");
  const [passwordRepeatInput, setPasswordRepeatInput] = useState("");
  const [changeButtonClickable, setChangeButtonClickable] = useState(true);
  const [passwordMatched, setPasswordMatched] = useState(false);

  useEffect(() => {
    if (passwordInput.length >= 6 && passwordRepeatInput.length >= 6) {
      if (passwordInput === passwordRepeatInput) {
        setPasswordMatched(true);
      } else {
        setPasswordMatched(false);
      }
    } else {
      setPasswordMatched(false);
    }
  }, [passwordInput, passwordRepeatInput]);

  const passwordRevealHandler = () => {
    if (passwordReveal === "password") {
      setPasswordReveal("text");
    }
    if (passwordReveal === "text") {
      setPasswordReveal("password");
    }
  };
  const passwordRepeatRevealHandler = () => {
    if (passwordRepeatReveal === "password") {
      setPasswordRepeatReveal("text");
    }
    if (passwordRepeatReveal === "text") {
      setPasswordRepeatReveal("password");
    }
  };
  const changeHandler = () => {
    if (passwordMatched) {
      if (changeButtonClickable) {
        setChangeButtonClickable(false);
        formData.append("email", forgotEmail);
        formData.append(
          "pin",
          otpNumbers[0] + otpNumbers[1] + otpNumbers[2] + otpNumbers[3]
        );
        formData.append("password", passwordInput);
        axios
          .post(distributionUrl + "panel-oauth/guest/forgot", formData)
          .then((res) => {
            if (res.status === 200) {
              setPopupType("Success");
              setPopupMessage("passwordChanged");
              setPopup(true);
              setOtpInput(false);
              navigate("/login");
            }
          })
          .catch((err) => {
            setChangeButtonClickable(true);
          });
      }
    } else {
      setPopupType("Warning");
      setPopupMessage("passwordMismatched");
      setPopup(true);
    }
  };
  return (
    <div
      className="login"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          changeHandler();
        }
      }}
    >
      <h5 className="font-semibold text-2xl pb-8 w-full text-center">
        Нууц үг солих
      </h5>
      <h5 className="text-base pt-6 pb-3">Нууц үг</h5>
      <div className="password-input">
        <input
          type={passwordReveal}
          placeholder="Нууц үг оруулах"
          onChange={(value) => {
            setPasswordInput(value.target.value);
          }}
        />
        <div
          onClick={() => {
            passwordRevealHandler();
          }}
        >
          <IconController
            src={
              passwordReveal === "password"
                ? assets.svg.passwordEye
                : assets.svg.passwordEyeOff
            }
            className="password-eye cursor-pointer"
          />
        </div>
      </div>
      <h5 className="text-base pt-6 pb-3">Нууц үг давтах</h5>
      <div className="password-input">
        <input
          type={passwordRepeatReveal}
          placeholder="Нууц үг оруулах"
          onChange={(value) => {
            setPasswordRepeatInput(value.target.value);
          }}
        />
        <div
          onClick={() => {
            passwordRepeatRevealHandler();
          }}
        >
          <IconController
            src={
              passwordRepeatReveal === "password"
                ? assets.svg.passwordEye
                : assets.svg.passwordEyeOff
            }
            className="password-eye cursor-pointer"
            alt=""
          />
        </div>
      </div>
      <Ripples color="#ffffff40" during={600} className="rounded-lg">
        <ChangeButton
          className={`mt-8  ${
            changeButtonClickable ? "cursor-pointer" : "cursor-wait"
          }`}
          onClick={() => {
            changeHandler();
          }}
        >
          <h5
            className={`py-4 font-semibold text-base text-white ${
              changeButtonClickable ? "" : "opacity-50"
            }`}
          >
            Солих
          </h5>
        </ChangeButton>
      </Ripples>
    </div>
  );
};

export default ModalChangePassword;
